export default {
  area: "Area",
  attachment: "Attachment",
  attributes: "Attributes",
  error: "Bug",
  location: "Location",
  issue: "Issue",
  item: "Item",
  layout: "Layout",
  model: "Model",
  performed_work: "Performed Work",
  to_do: "To-do",
  notification: "Notification",
  unsubmitted_work: "Unsubmitted work",
  workspace: "Workspace",
  photo: "Photo",
  image: "Image",
  work_order: "Work Order",
  zone: "Zone",
}
